import { render, staticRenderFns } from "./lottery_page_dialog.vue?vue&type=template&id=4868a577"
import script from "./lottery_page_dialog.vue?vue&type=script&lang=ts"
export * from "./lottery_page_dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports